import client from '@js/client'
import resources from '@js/resources'
import { snakeKeyToCamelKeyRecursive, } from '@js/str-utils'

const getDefaultState = () => {
  return {
    tenantSkills: null,
    tenantSkillEdges: null,
  };
};

const aggregatedSkills = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    tenantSkillsLoaded: state => state.tenantSkills != null,
    tenantSkillEdgesLoaded: state => state.tenantSkillEdges != null,
  },
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    setTenantSkills (state, data) {
      state.tenantSkills = data.skills.reduce((result, elem) => {
        result.push(snakeKeyToCamelKeyRecursive(elem));
        return result;
      }, []);
    },
    setTenantSkillEdges (state, data) {
      state.tenantSkillEdges = data.edges.reduce((result, elem) => {
        result.push(snakeKeyToCamelKeyRecursive(elem));
        return result;
      }, []);
    },
  },
  actions: {
    async fetchTenantSkills ({ state, commit, rootGetters }) {
      const initTenantSkillLoaded = state.tenantSkillLoaded;
      state.tenantSkillLoaded = false;
      const tenantDomain = await rootGetters['tenant/getTenantDomain'];
      const payload = {};
      const res = await client.post(
        resources['aggregatedSkills'](tenantDomain), payload);
      await commit('setTenantSkills', res.data);
      await commit('setTenantSkillEdges', res.data);
      state.tenantSkillLoaded = await true;
      return res;
    },
  },
};

export default aggregatedSkills;
